var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.82,
    height: 24,
    viewBox: "0 0 21.82 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon-Color",
    className: "cls-1",
    d: "M14.09,0a3.28,3.28,0,0,1,3.27,3.08V4.36h4.37a1.09,1.09,0,0,1,.12,2.18H20.64V20.73A3.27,3.27,0,0,1,17.56,24H6.45a3.27,3.27,0,0,1-3.26-3.08V6.55H2.09A1.09,1.09,0,0,1,2,4.37H6.45V3.27A3.27,3.27,0,0,1,9.53,0h4.56Zm4.36,6.55H5.36V20.73a1.08,1.08,0,0,0,1,1.08h11a1.1,1.1,0,0,0,1.09-1V6.55ZM9.73,9.82a1.08,1.08,0,0,1,1.08,1v6.67a1.09,1.09,0,0,1-1.09,1.1,1.11,1.11,0,0,1-1.09-1V10.91A1.09,1.09,0,0,1,9.73,9.82Zm4.36,0a1.08,1.08,0,0,1,1.08,1v6.67a1.09,1.09,0,0,1-2.17.13V10.91A1.09,1.09,0,0,1,14.09,9.82Zm0-7.64H9.73a1.1,1.1,0,0,0-1.09,1V4.36h6.54V3.27a1.08,1.08,0,0,0-1-1.08Z",
    transform: "translate(-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.72d015f1dc743425bb95cc5152bf1fab.svg";
export { ForwardRef as ReactComponent };